export default __webpack_public_path__ + "static/media/LINK.95977034.svg";